import { makeStyles } from '@material-ui/core';
import { bottomSheetShadow } from '../../theme';

const useStyles = makeStyles((theme) => ({
  mobileNavigation: {
    position: 'sticky',
    bottom: 0,
    background: theme.palette.white.main,
    zIndex: 10,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    boxShadow: `0px -2px 5px 0px ${bottomSheetShadow}`,
  },
  rowTitle: {
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    textAlign: 'left',
    textTransform: 'uppercase',
    color: theme.palette.black.main,
    [theme.breakpoints.up(1024)]: {
      fontSize: 20,
    },
    [theme.breakpoints.down(1024)]: {
      fontSize: 14,
    },
  },
  searchNavigation: {
    justifyContent: 'flex-start',
  },
  medicalEmptyGridItem: {
    width: 108,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  divider: {
    width: '100%',
    border: '6px solid #F4F5F6',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  searchNavigationButton: {
    justifyContent: 'flex-start',
  },
  attachmentTitle: {
    marginTop: '1.5rem',
    marginBottom: '1rem',
    fontSize: 20,
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  accidentInfoPageHeader: {
    paddingBottom: '1rem',
  },
  addIcon: {
    color: theme.palette.primary.main,
  },
  plusIcon: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: 'max-content',
    marginTop: 20,
    marginBottom: 10,
    fontSize: 20,
    cursor: 'pointer',

    '& i': {
      fontSize: 20,
    },
    '& p': {
      lineHeight: '19px',
      marginLeft: 3,
      color: theme.palette.primary.main,
    },
  },
  errorText: {
    color: theme.palette.error.main,
  },
}));

export default useStyles;
